import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const buildItems = [
  {
    num: '01',
    icon: 'ri-smartphone-line',
    title: 'Application Mobile',
    description: "Application iOS et Android sur mesure pour votre métier. Fonctionne sans connexion stable, synchronisation automatique des données.",
    examples: 'Gestion de flotte, suivi terrain, collecte de données, app client',
  },
  {
    num: '02',
    icon: 'ri-window-line',
    title: 'Site Web & Plateforme',
    description: "Site vitrine professionnel ou plateforme métier complète. Rapide, sécurisé, optimisé pour l'Afrique.",
    examples: 'Site institutionnel, e-commerce, portail client, intranet',
  },
  {
    num: '03',
    icon: 'ri-dashboard-line',
    title: 'Dashboard & Reporting',
    description: "Tableau de bord sur mesure pour piloter votre activité en temps réel. Visualisation de données, exports, alertes.",
    examples: 'Suivi commercial, reporting RH, analytics opérationnel',
  },
  {
    num: '04',
    icon: 'ri-database-2-line',
    title: 'Système de Gestion Métier',
    description: "Logiciel sur mesure pour digitaliser vos processus internes. Remplace Excel et le papier.",
    examples: 'Gestion stocks, facturation, RH, registres clients',
  },
];

const stackItems = [
  {
    icon: 'ri-flutter-line',
    title: 'Flutter',
    description: 'Applications mobiles iOS et Android depuis une seule base de code. Performant sur appareils bas de gamme.',
    tag: 'Applications mobiles',
  },
  {
    icon: 'ri-reactjs-line',
    title: 'Next.js / React',
    description: 'Sites web et plateformes rapides, sécurisées et référencées sur Google. Standard mondial du web moderne.',
    tag: 'Web & Plateformes',
  },
  {
    icon: 'ri-database-2-line',
    title: 'PostgreSQL',
    description: "Base de données robuste et souveraine. Vos données restent chez vous, pas chez un géant américain.",
    tag: 'Données & Stockage',
  },
  {
    icon: 'ri-cloud-line',
    title: 'Cloud Souverain',
    description: "Hébergement en Afrique ou en Europe selon vos exigences réglementaires. Conformité CEDEAO et RGPD.",
    tag: 'Hébergement',
  },
  {
    icon: 'ri-wifi-off-line',
    title: 'Offline-First',
    description: "Nos applications fonctionnent sans connexion internet. Les données se synchronisent automatiquement dès que le réseau revient.",
    tag: 'Technologie clé',
  },
];

export default function DigitalStudioPage() {
  const scrollToContact = () => {
    window.REACT_APP_NAVIGATE('/contact');
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#1B2A4A] via-[#243552] to-[#1B2A4A] text-white py-24 mt-20">
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-transparent"></div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-4 leading-tight">Studio Digital</h1>
            <p className="text-xl text-white/90 leading-relaxed">
              Des applications qui fonctionnent partout en Afrique
            </p>
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Pour qui Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-[#1B2A4A] mb-3">Pour qui ?</h2>
            <p className="text-gray-500 max-w-3xl mx-auto text-base leading-relaxed">
              PME, startups, ONG et entreprises africaines qui ont besoin d'outils fiables
            </p>
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Ce que nous construisons */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1B2A4A] mb-3">
              Ce que nous construisons pour vous
            </h2>
            <p className="text-gray-400 text-sm">Quatre types de solutions, une seule équipe</p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-6xl mx-auto">
            {buildItems.map((item) => (
              <div
                key={item.num}
                className="relative bg-[#F5F5F5] rounded-xl p-8 border-l-4 border-l-[#D4A017] hover:shadow-md transition-all duration-300 group"
              >
                <div className="flex items-center justify-end mb-5">
                  <span className="w-9 h-9 flex items-center justify-center bg-[#D4A017] text-white text-sm font-bold rounded-full flex-shrink-0">
                    {item.num}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-[#1B2A4A] mb-3">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{item.description}</p>
                <p className="text-gray-400 text-xs italic">Exemples : {item.examples}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Notre Stack Technique */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1B2A4A] mb-3">Notre Stack Technique</h2>
            <p className="text-gray-400 text-sm">Des technologies modernes, choisies pour l'Afrique</p>
          </div>

          <div className="max-w-4xl mx-auto divide-y divide-gray-100">
            {stackItems.map((item, idx) => (
              <div
                key={idx}
                className="flex items-center gap-6 py-7 group hover:bg-[#F5F5F5] px-4 rounded-xl transition-colors duration-200 cursor-default"
              >
                <div className="w-14 h-14 flex items-center justify-center bg-[#F5F5F5] border border-[#D4A017]/30 rounded-xl flex-shrink-0 group-hover:bg-[#D4A017]/10 transition-colors duration-300">
                  <i className={`${item.icon} text-2xl text-[#D4A017]`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-bold text-[#1B2A4A] mb-1">{item.title}</h3>
                  <p className="text-gray-500 text-sm leading-relaxed">{item.description}</p>
                </div>
                <div className="flex-shrink-0">
                  <span className="px-4 py-2 bg-[#D4A017]/10 text-[#D4A017] text-xs font-semibold rounded-full border border-[#D4A017]/20 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Comment ça se passe */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-[#1B2A4A] mb-3">Comment ça se passe ?</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {[
              { n: 1, title: 'Cadrage — 1 semaine', desc: "On comprend votre métier, vos utilisateurs et vos contraintes techniques." },
              { n: 2, title: 'Conception — 1 à 2 semaines', desc: "Maquettes interactives validées avec vous avant de coder une seule ligne." },
              { n: 3, title: 'Développement — 4 à 10 semaines', desc: "Développement itératif avec démonstrations régulières. Vous voyez l'avancement." },
              { n: 4, title: 'Livraison & Support', desc: "Déploiement, formation de vos équipes et support continu." },
            ].map((step) => (
              <div key={step.n} className="bg-[#F5F5F5] border-l-4 border-l-[#D4A017] rounded-xl p-8 hover:shadow-md transition-all duration-300">
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 bg-[#D4A017] rounded-full flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">{step.n}</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#1B2A4A] mb-2">{step.title}</h3>
                    <p className="text-gray-600 text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gold divider */}
      <div className="h-px bg-gradient-to-r from-transparent via-[#D4A017] to-transparent" />

      {/* Final CTA */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-[#1B2A4A] mb-4">Un projet en tête ?</h2>
          <p className="text-gray-500 text-lg mb-10 leading-relaxed">
            Dites-nous ce que vous voulez construire, on vous dit comment et en combien de temps.
          </p>
          <button
            onClick={scrollToContact}
            className="inline-block px-10 py-4 bg-[#D4A017] text-white font-semibold rounded-lg hover:bg-[#B8900F] transition-colors text-base whitespace-nowrap cursor-pointer shadow-sm"
          >
            Décrire mon projet
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
